<template>
    <div v-if="$route.query.view == null" class="searchRow">

        <div class="autosuggestContainer" style="z-index: 10000;">
            <div
                role="combobox"
                aria-haspopup="listbox"
                aria-owns="react-autowhatever-1"
                aria-expanded="false"
                style="z-index: 10000000000;"
                class="react-autosuggest__container">
                <input id="myInput2" class="react-autosuggest__input" type="text" v-model="query" @focus="showAllItems" @input="filterList" placeholder='הקלד כתובת / שם רחוב / שם ישוב'
                @keydown.down="moveSelection(1)" 
                @keydown.up="moveSelection(-1)" 
                @keydown.enter="selectCurrentItem" >

                <div style="z-index: 1000;" v-if="items.length" id="react-autowhatever-1" role="listbox" class="react-autosuggest__suggestions-container react-autosuggest__suggestions-container--open" data-font-size="10" data-font-size-type="px">
                    <ul role="listbox" class="react-autosuggest__suggestions-list">
                        <li style="z-index: 1000000000;"
                        v-for="(item, index) in items" 
                        :key="item.id" 
                        @click="selectItem(item)" 
                        role="option" 
                        :id="'react-autowhatever-1--item-' + index" 
                        :aria-selected="selectedIndex === index"
                        :class="['react-autosuggest__suggestion', {'react-autosuggest__suggestion--highlighted': selectedIndex === index}]"
                        :data-suggestion-index="index">
                        <div class="suggestionRow">
                          <span class="location">
                            <span v-html="highlightText(item.text, query)"></span>
                          </span>
                          <span class="type">{{ types[item.type.toLowerCase()] }}</span>
                        </div>
                      </li>
                    </ul>
                </div>
            </div>
            <div class="magnifyWrap">
                <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                    class="magnifyIcon"
                >
                    <title>search</title>
                    <g
                        id="search-24"
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                    >
                        <rect
                            id="Rectangle"
                            x="0"
                            y="0"
                            width="24"
                            height="24"
                        ></rect>
                        <path
                            d="M18.0104076,15.5104076 L21.0104076,15.5104076 L21.0104076,22.0104076 C21.0104076,22.8388348 20.3388348,23.5104076 19.5104076,23.5104076 C18.6819805,23.5104076 18.0104076,22.8388348 18.0104076,22.0104076 L18.0104076,15.5104076 L18.0104076,15.5104076 Z"
                            id="Rectangle-hand"
                            fill="#000000"
                            transform="translate(19.510408, 19.510408) rotate(-45.000000) translate(-19.510408, -19.510408)"
                        ></path>
                        <circle
                            id="Oval"
                            stroke="#000000"
                            stroke-width="2"
                            cx="10.5"
                            cy="10.5"
                            r="8.5"
                        ></circle>
                    </g>
                </svg>
            </div>
            <button v-if="query != ''" @click="query = ''"
                class="deleteTextIcon show"
                aria-label="מחיקת הטקסט בשורת חיפוש והתחלה מחדש"
            >
                <img
                    class="icon"
                    src="/images/autosuggestCloseIcon.png"
                    alt=""
                />
            </button>
        </div>
        <div class="GPSWrapper">
            <button class="GPSButton">
                <div class="GPSIcon"></div>
                <span class="GPSText" @click="zoomCurrentLocation()" c
                    >חיפוש לפי מיקומי הנוכחי</span
                >
            </button>
        </div>
        <div class="forBtnWrapper">
            <button @click="showResults" class="btn arrowBtn">
                <div class="arrowWrap white">
                    <span class="long"></span>
                </div>
            </button>
            <div
                v-show="
                    $store.state.searchError == true && query == ''
                "
                class="error centerd searchErr"
            >
                יש להזין כתובת תקינה
            </div>
        </div>

    </div>
    <div v-else :class="[searchMobileActive == true
            ? 'searchRow  mobile-active'
            : '',
            'searchRow',
        ]">

        <div class="autosuggestContainer" style="z-index: 100000000000;">
            <div style="z-index: 100000000000;"
                role="combobox"
                aria-haspopup="listbox"
                aria-owns="react-autowhatever-1"
                aria-expanded="false"
                class="react-autosuggest__container">
                <input id="myInput2" class="react-autosuggest__input" type="text" v-model="query" @focus="showAllItems" @input="filterList" placeholder='הקלד כתובת / שם רחוב / שם ישוב'
                @keydown.down="moveSelection(1)" 
                @keydown.up="moveSelection(-1)" 
                @keydown.enter="selectCurrentItem" >

                <div v-if="items.length" id="react-autowhatever-1" role="listbox" class="react-autosuggest__suggestions-container react-autosuggest__suggestions-container--open" data-font-size="10" data-font-size-type="px">
                    <ul role="listbox" class="react-autosuggest__suggestions-list" style="z-index: 100000000000;">
                        <li 
                        v-for="(item, index) in items" 
                        style="z-index: 100000000000;"
                        :key="item.id" 
                        @click="selectItem(item)" 
                        role="option" 
                        :id="'react-autowhatever-1--item-' + index" 
                        :aria-selected="selectedIndex === index"
                        :class="['react-autosuggest__suggestion', {'react-autosuggest__suggestion--highlighted': selectedIndex === index}]"
                        :data-suggestion-index="index">
                        <div class="suggestionRow">
                          <span class="location">
                            <span v-html="highlightText(item.text, query)"></span>
                          </span>
                          <span class="type">{{ types[item.type.toLowerCase()] }}</span>
                        </div>
                      </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="GPSWrapper">
            <button @click="zoomCurrentLocation()" class="GPSButton">
              <div class="GPSIcon"></div>
              <span class="GPSText">חיפוש לפי מיקומי הנוכחי</span>
            </button>
          </div>
          <div class="forBtnWrapper">
            <button @click="showResults()" class="">
              <div class="arrowWrap">
                <span class="long longHeader"></span>
              </div>
            </button>
            <div
              v-show="$store.state.searchError == true && search == null"
              class="error centerd searchErr"
            >
              יש להזין כתובת תקינה
            </div>
          </div>
    </div>
</template>

<script>

//Vue component

export default {
  name: "SearchBox",
  data() {
    return {
        selectedIndex: -1,
        types: {
                'address': 'כתובת', 'neighborhood': 'שכונה', 'street': 'רחוב', 
                'settlement': 'יישוב', 'parks': 'שמורות טבע וגנים', 'institutes': 'מוסדות', 
                'junction': 'צומת', 'block': 'גוש', 'parcel': 'חלקה', 'ways': 'דרכים', 
                'poi': 'נקודת עניין', 'statistic': 'איזור סטטיסטי'
        },
        query: '',
        items: [],
        filteredItems: [],

        showContactMsg: false,
        contactText: "",
    };
  },

  mounted(){

    // listen to mouse click outside of the search box
    document.addEventListener('click', this.handleClickOutside);


  },

  methods: {
    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.filteredItems = [];
        this.items = [];
        this.query = '';
      }
    },
    moveSelection(direction) {
      if (this.items.length === 0) return;

      this.selectedIndex += direction;

      // Ensure the selectedIndex wraps around appropriately
      if (this.selectedIndex < 0) {
        this.selectedIndex = this.items.length - 1;
      } else if (this.selectedIndex >= this.items.length) {
        this.selectedIndex = 0;
      }

      // Optionally, scroll the selected item into view
      this.$nextTick(() => {
        const selectedElement = document.querySelector(
          `.react-autosuggest__suggestion[data-suggestion-index="${this.selectedIndex}"]`
        );
        if (selectedElement) {
          selectedElement.scrollIntoView({ block: 'nearest' });
        }
      });
    },
    selectCurrentItem() {
      if (this.selectedIndex >= 0 && this.selectedIndex < this.items.length) {
        this.selectItem(this.items[this.selectedIndex]);
      }
      else {
        // get item 0 if exists..
        if (this.items.length > 0) {
            this.selectItem(this.items[0]);
        }
      }
    },
    zoomCurrentLocation() {
        var appVue = this;
        appVue.$store.state.loading = true;
        appVue.mixin_zoomCurrentLocation(appVue);
    },
    highlightText(text, query) {
        // eslint-disable-next-line
        const sanitizedQuery = query.trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regex = new RegExp(`(${sanitizedQuery})`, 'gi');
        return text.replace(regex, '<span class="highlight blue">$1</span>');
    },
    showAllItems() {
        this.filteredItems = this.items;
    },
    filterList() {
        if (this.query == "" || this.query == null){
            return;
        }
        var url = "https://es.govmap.gov.il/TldSearch/api/AutoComplete?query=" + this.query + "&ids=276267023&gid=govmap";
        fetch(url)
        .then(response => response.json())
        .then(data => {
            // SETTLEMENT
            // NEIGHBORHOOD
            // STREET
            // ADDRESS
            // KPARCEL_ALL
            this.items = [];
            if (data.res.SETTLEMENT) {
                data.res.SETTLEMENT.forEach((item) => {
                    // push item only if not in item..
                    if (this.items.find(x => x.text === item.Value) == undefined) {
                        this.items.push({
                            id: item.Key,
                            text: item.Value,
                            type: 'SETTLEMENT',
                            rank: item.Rank
                        });
                    }
                });
            }
            if (data.res.NEIGHBORHOOD) {

                var neigh_index = this.$store.state.neigh;
                data.res.NEIGHBORHOOD.forEach((item) => {
                    //neigh_index has own propery item.Key
                    if (neigh_index[item.Key] == undefined) {
                        return;
                    }
                    if (this.items.find(x => x.text === item.Value) == undefined) {
                        this.items.push({
                            id: item.Key,
                            text: item.Value,
                            type: 'NEIGHBORHOOD',
                            rank: item.Rank
                        });
                    }
                });
            }
            if (data.res.STREET) {
                data.res.STREET.forEach((item) => {
                    // try to getInfo from the street
                    // const api_base = this.$store.state.config.api_base;
                    // const api_url = api_base + "/GetInfo";
                    
                    // const payload = {
                    //     base_name: 'street_id',
                    //     base_id: item.Key,
                    // };

                    // fetch(api_url, {
                    //     method: "POST",
                    //     headers: {
                    //         "Content-Type": "application/json",
                    //     },
                    //     body: JSON.stringify(payload),
                    // })
                    // .then(response => response.json())
                    // .then(data => {
                    //     if (data.statusCode == 404) {
                    //         return;
                    //     }
                    //     else{
                            //if (this.items.find(x => x.text === item.Value) == undefined) {
                                this.items.push({
                                    id: item.Key,
                                    text: item.Value,
                                    type: 'STREET',
                                    rank: item.Rank
                                });
                            //}
                        //}
                        
                   // });
                });
            }
            if (data.res.ADDRESS) {
                data.res.ADDRESS.forEach((item) => {
                    if (this.items.find(x => x.text === item.Value) == undefined) {
                        this.items.push({
                            id: item.Key,
                            text: item.Value,
                            type: 'ADDRESS',
                            rank: item.Rank
                        });
                    }   
                });
            }
            if (data.res.GOVMAP_PARCEL_ALL) {
                data.res.GOVMAP_PARCEL_ALL.forEach((item) => {
                    if (this.items.find(x => x.text === item.Value) == undefined) {
                        this.items.push({
                            id: item.Key,
                            text: item.Value,
                            type: 'KPARCEL_ALL',
                            rank: item.Rank
                        });
                    }
                });
            }

            const display_order = ['SETTLEMENT', 'NEIGHBORHOOD', 'STREET', 'ADDRESS',  'KPARCEL_ALL'];
            this.items.sort((a, b) => {
                return display_order.indexOf(a.type) - display_order.indexOf(b.type);
            });

            this.filteredItems = this.items;
        });
    },
    selectItem(item) {
        this.query = item.text;
        this.filteredItems = [];
        this.items = [];

        var searchTypes = {
            SETTLEMENT: 8,
            NEIGHBORHOOD: 4,
            STREET: 2,
            ADDRESS: 1,
            KPARCEL_ALL: 16384,
        };

        this.$store.state.searchType = searchTypes[item.type];
        this.$store.state.searchTypeText = item.type;
        this.$store.state.search = this.query;

        // showResults
        this.showResults();		
    },
    async showResults() {
        var appVue = this;
        await appVue.mixin_showResults(appVue);
    },
},
  computed: {
    appVue_or_homeView(){
        // get the parent component
        return this.$parent.$options.name;
    },
    isMobile() {
        return window.innerWidth < 1024;
    },
    searchMobileActive() {
        return this.$parent.searchMobileActive;
    },
  },
};

</script>


<style scoped>

.react-autosuggest__suggestion--highlighted {
    background-color: #f0f0f0;
  }

  .arrowBtn {
    transition: none;
  }
  .arrowWrap {
    transition: none;
  }

  </style>  

